import React from 'react';
import {Box, Card, CardActionArea, Typography} from "@mui/material";
import {ArrowBackRounded} from "@mui/icons-material";

const _UsersActions = ({icon, title, description, onClick}) => {
    return (
        <Card
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                height: '100%',
                overflow: 'hidden',
                transition: 'all 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 28px rgba(28, 139, 156, 0.1)',
                    borderColor: 'primary.main',
                    '& .action-arrow': {
                        transform: 'translateX(-4px)',
                        color: 'primary.main',
                    }
                }
            }}
        >
            <CardActionArea
                onClick={onClick}
                sx={{
                    p: { xs: 2.5, sm: 3 },
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    textAlign: 'right'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.2 }}>
                    <Box
                        sx={{
                            width: 58,
                            height: 58,
                            borderRadius: 3.5,
                            bgcolor: 'rgba(28, 139, 156, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1.2,
                            boxShadow: 'inset 0 0 0 1px rgba(28, 139, 156, 0.12)',
                            flexShrink: 0,
                            '& img': {
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain'
                            }
                        }}
                    >
                        {icon}
                    </Box>

                    <Box sx={{ textAlign: 'right', direction: 'rtl', flex: 1 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 800,
                                fontSize: '1.05rem',
                                color: 'text.primary',
                                mb: 0.5,
                                textAlign: 'right',
                                direction: 'rtl',
                            }}
                        >
                            {title}
                        </Typography>
                        {description && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                    lineHeight: 1.7,
                                    display: 'block',
                                    textAlign: 'justify',
                                    textJustify: 'inter-word',
                                    direction: 'rtl',
                                    fontSize: '0.82rem',
                                }}
                            >
                                {description}
                            </Typography>
                        )}
                    </Box>
                </Box>

                <ArrowBackRounded
                    className="action-arrow"
                    sx={{
                        fontSize: 20,
                        color: 'text.disabled',
                        transition: 'all 0.25s ease',
                        mr: 1
                    }}
                />
            </CardActionArea>
        </Card>
    );
};

export default _UsersActions;
